<template>
  <v-dialog v-model="showForm" persistent max-width="700px">
    <v-card>
      <v-card-title>
        <span class="text-h5 gray--text"
          >Sinais vitais ({{ surgeryMomentTitle }})</span
        >
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row align="end">
            <v-col cols="5">
              <v-row dense>
                <v-col class="font-weight-bold"> Pressão arterial </v-col>
              </v-row>

              <v-row dense align="center">
                <v-col>
                  <v-text-field
                    v-model="systolicBloodPressure"
                    dense
                    hide-details
                    outlined
                    background-color="white"
                    :disabled="disabled"
                  />
                </v-col>

                <v-col cols="auto"> X </v-col>

                <v-col>
                  <v-text-field
                    v-model="diastolicBloodPressure"
                    dense
                    hide-details
                    outlined
                    background-color="white"
                    suffix="mmHg"
                    :disabled="disabled"
                  />
                </v-col>
              </v-row>
            </v-col>

            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold"> Pulso </v-col>
              </v-row>

              <v-row dense align="center">
                <v-col>
                  <v-text-field
                    v-model="pulseRate"
                    dense
                    hide-details
                    outlined
                    background-color="white"
                    suffix="bpm"
                    :disabled="disabled"
                  />
                </v-col>
              </v-row>
            </v-col>

            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold"> Temperatura </v-col>
              </v-row>

              <v-row dense align="center">
                <v-col>
                  <v-text-field
                    v-model="temperature"
                    dense
                    hide-details
                    outlined
                    background-color="white"
                    suffix="°C"
                    :disabled="disabled"
                  />
                </v-col>
              </v-row>
            </v-col>

            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold"> Glicemia </v-col>
              </v-row>

              <v-row dense align="center">
                <v-col>
                  <v-text-field
                    v-model="glucoseLevel"
                    dense
                    hide-details
                    outlined
                    background-color="white"
                    suffix="mg/dL"
                    :disabled="disabled"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold"> Oximetria </v-col>
              </v-row>

              <v-row dense align="center">
                <v-col>
                  <v-text-field
                    v-model="oximetry"
                    dense
                    hide-details
                    outlined
                    background-color="white"
                    suffix="SpO2"
                    :disabled="disabled"
                  />
                </v-col>
              </v-row>
            </v-col>

            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold"> Frequência respiratória </v-col>
              </v-row>

              <v-row dense align="center">
                <v-col>
                  <v-text-field
                    v-model="respiratoryRate"
                    dense
                    hide-details
                    outlined
                    background-color="white"
                    suffix="irpm"
                    :disabled="disabled"
                  />
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="auto">
              <v-row dense>
                <v-col class="font-weight-bold"> Dor </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  <v-radio-group
                    v-model="eyePain"
                    
                    mandatory
                    dense
                    hide-details
                    class="mt-0"
                    @change="changeEyePain"
                    :disabled="disabled"
                  >
                    <v-radio label="Sim" :value="true" />
                    <v-radio label="Não" :value="false" />
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-col>
            
            <v-col align-self="center">
              <v-text-field
                label="Escala de dor"
                v-model="painLevel"
                dense
                hide-details
                outlined
                background-color="white"
                :disabled="!eyePain || disabled"
              />
                
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-textarea
            v-model.trim="observation"
            outlined
            dense
            hide-details
            label="Observações"
            background-color="white"
          />
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="auto">
              <v-btn
                color="light-blue"
                dark
                @click="saveSurgeryVitalMeasurement"
                :disabled="disabled"
              >
                Salvar
              </v-btn>
            </v-col>

            <v-col cols="auto">
              <v-btn
                color="gray lighten-1"
                dark
                @click="cancelVitalMeasurement"
              >
                cancelar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SurgeryVitalMeasurementForm",
  props: {
    surgery: Object,
    showVitalMeasurementForm: {
      type: Boolean,
      default: false,
    },
    toggleShow: {
      type: Function,
      default: () => {},
    },
    surgeryMoment: {
      type: String,
      default: "",
    },
    refreshSurgery: Function,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      systolicBloodPressure: "",
      diastolicBloodPressure: "",
      pulseRate: "",
      temperature: "",
      glucoseLevel: "",
      eyePain: false,
      painLevel: "",
      oximetry: "",
      respiratoryRate:"",
      observation: ""
    };
  },
  computed: {
    showForm: {
      get() {
        return this.showVitalMeasurementForm;
      },
      set() {
        this.toggleShow();
      },
    },
    surgeryMomentTitle() {
      switch (this.surgeryMoment) {
        case "preoperative":
          return "Pré-operatório";
        case "intraoperative":
          return "Intra-operatório";
        case "postoperative":
          return "Pós-operatório";
        default:
          return "";
      }
    },
  },
  methods: {
    changeEyePain() {
      this.painLevel = "";
    },
    saveSurgeryVitalMeasurement() {
      if (this.disabled) return;

      return this.apolloMutate({
        mutation: require("@/graphql/surgery/save_surgery_vital_measurement.gql"),
        variables: {
          surgeryId: this.surgery.id,
          surgeryMoment: this.surgeryMoment,
          systolicBloodPressure: this.systolicBloodPressure,
          diastolicBloodPressure: this.diastolicBloodPressure,
          pulseRate: this.pulseRate,
          temperature: this.temperature,
          glucoseLevel: this.glucoseLevel,
          eyePain: this.eyePain,
          painLevel: this.painLevel,
          oximetry: this.oximetry,
          respiratoryRate:this.respiratoryRate,
          observation: this.observation
        },
      }).then(() => {
        this.cancelVitalMeasurement();

        this.refreshSurgery();
      });
    },
    cancelVitalMeasurement() {
      this.systolicBloodPressure = "";
      this.diastolicBloodPressure = "";
      this.pulseRate = "";
      this.temperature = "";
      this.glucoseLevel = "";
      this.eyePain = false;
      this.painLevel = "";
      this.oximetry = "";
      this.respiratoryRate = "";
      this.observation = ""

      this.toggleShow();
    },
  },
};
</script>

<style lang="scss" scoped></style>
